import React from 'react';
import MkIcon from '../MkIcon';
import MkPill from '../MkPill';

// B6 — Hard Block is Android-only; the iPhone limit is stated right under it.
const BmbHardBlock = () => (
  <section className="mk-hardblock section" id="hard-block" aria-labelledby="mk-hardblock-title">
    <div className="container-sm">
      <div className="section-inner">
        <div className="mk-card mk-hardblock__card reveal-from-bottom">
          <span className="mk-icon-tile mk-icon-tile--bmb mk-icon-tile--lg">
            <MkIcon name="shield-lock" size={32} />
          </span>
          <div className="mk-hardblock__text">
            <MkPill variant="platform">Android only</MkPill>
            <h2 id="mk-hardblock-title" className="mk-h2 mk-h2--sm">
              On Android, go harder with Hard Block
            </h2>
            <p className="mk-body">
              Block apps entirely, with no pause: opening one sends you back to the home screen. Timed focus sessions are
              free; "until off" sessions and per-app Hard Block come with Premium.
            </p>
            <p className="mk-micro">On iPhone, Bring Me Back pauses apps and filters websites, but it can't block apps.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbHardBlock;
